import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import BorrowerDashboardSC from './borrower-dashboard.styled';
import InfoBanner from '../../../components/info-banner';
import BorrowerDashBanner from '../../../components/borrower-dash-banner';
import ContentWrap from '../../../components/content-wrap';
import BorrowerDashContent from '../../../components/borrower-dash-content';

const _BorrowerDashboard = ({ dashboardData, user }) => {
  // Check if access is false to hide banner
  const userAreaAccess = (user && user.userAreaAccess) || (dashboardData && dashboardData.userAreaAccess);
  const shouldShowBanner = !userAreaAccess || userAreaAccess.access !== false;

  return (
    <BorrowerDashboardSC>
      {shouldShowBanner && (
        <InfoBanner>
          <BorrowerDashBanner bannerData={dashboardData} />
        </InfoBanner>
      )}
      <ContentWrap>
        <BorrowerDashContent dashboardData={dashboardData} user={user} />
      </ContentWrap>
    </BorrowerDashboardSC>
  );
};

const mapStateToProps = (state) => {
  return {
    dashboardData: state.dashboard,
    user: state.user,
  };
};

const BorrowerDashboard = withRouter(connect(mapStateToProps)(_BorrowerDashboard));

export default BorrowerDashboard;
